export const POST = 'POST'
export const PUT = 'PUT'
export const GET = 'GET'

export const FHIR_METHODS = [
	{ TYPE: POST, RESOURCE: 'createResource' },
	{ TYPE: PUT, RESOURCE: 'updateResource' },
]
